import React from "react";
import { connect } from "react-redux";
import * as resActions from "../../modules/resources";
import PropTypes from "prop-types";
import Button from "Components/button/Button";
import Loader from "Components/loader/Loader";
import { calcPercentageAndRound } from "Utils/bytesFormats";
import LoadingBar from "Components/loadingBar/LoadingBar";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";

import cx from "classnames";
import s from "./Postmaster.scss";

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isLoggedUserTrial: PropTypes.func,
};

class PostmasterPage extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.getPostmaster();
  }

  goToSettings() {
    const {
      match: {
        params: { postmasterCode, domainCode, customerCode },
      },
    } = this.props;
    let url = `/domains/${domainCode}/email_accounts/${postmasterCode}/settings#limits`;
    if (this.context.isLoggedUserAdmin()) {
      url = `/customers/${customerCode}` + url;
    }

    this.props.history.push(url);
  }

  render() {
    const { postmaster, isPostmasterLoading } = this.props;

    if (isPostmasterLoading) {
      return <Loader />;
    }

    const postmasterPercentage = calcPercentageAndRound(
      postmaster.quota,
      postmaster.max_email_quota
    );

    let lastAuthString = <TranslatedString>detailInfo.data.never</TranslatedString>;
    if (postmaster.lastauth_datetime) {
      lastAuthString = `${postmaster.lastauth_datetime} via ${postmaster.lastauth_protocol}`;
    }

    return (
      <div className={s.postmaster}>
        <div className="sectionSP">
          <div className="infoSectionSP">
            <div className="settingTitle">{t("settings.section.postmaster.title")}</div>
            <div className="sectionDesc">{t("settings.section.postmaster.desc")}</div>
          </div>
          <div className="formsSectionSP">
            <div className={cx(s.wrapData, "inputFull2")}>
              <div className={s.label}>{t("detailInfo.label.postmasterAccount")}</div>
              <div className={s.data}>{postmaster.email_address}</div>
            </div>

            <div className={cx(s.wrapData, "inputFull2")}>
              <div className={s.label}>{t("detailInfo.label.quote")}</div>
              <div className={cx(s.data, s.quota)}>
                <div className={s.percentage}>{postmasterPercentage}</div>

                <LoadingBar pctg={postmasterPercentage} />
              </div>
            </div>
            <div className={cx(s.wrapData, "inputFull2")}>
              <div className={s.label}>{t("detailInfo.label.lastAccess")}</div>
              <div className={s.data}>{lastAuthString}</div>
            </div>
            <Button color="outline" onClick={this.goToSettings.bind(this)}>
              button.goToSettings
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

PostmasterPage.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  postmaster: resActions.getData("emailAccount.data.0", state),
  isPostmasterLoading: resActions.isResourceLoading("emailAccount", state),
});

const mapDispatchToProps = (dispatch, props) => {
  const domainCode = props.match.params.domainCode;
  const postmasterCode = props.match.params.postmasterCode;

  return {
    getPostmaster: () =>
      dispatch(resActions.callApi("getEmailAccount", "emailAccount", domainCode, postmasterCode)),
    refreshPostmaster: () =>
      dispatch(
        resActions.callApi("refreshEmailAccount", "emailAccount", domainCode, postmasterCode)
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PostmasterPage);
